/* eslint-disable no-unused-expressions */
// @mui
import { useTheme } from '@mui/material/styles';
import { useParams } from 'react-router-dom';
import {
  Grid,
  Container,
  TextField,
  CircularProgress,
  Backdrop,
  Stack,
  Box,
  MenuItem,
  Typography,
  ListSubheader,
  FormControl,
  InputLabel,
  Select,
  Card,
  Button,
  ListItemIcon,
} from '@mui/material';
import React, { useState } from 'react';
// components

import { collection, doc, getDoc, getDocs, orderBy, query } from 'firebase/firestore';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { format } from 'date-fns';
import AppWebsiteVisits1 from '../../sections/@dashboard/app/AppWebsiteVisits1';
import { db } from '../../firebase.config';
import Page from '../../components/Page';
// sections
import { AppCurrentVisits } from '../../sections/@dashboard/app';
import StyledMenu from '../../components/ui/StyledMenu';
import LucideIcon from '../../components/LucideIcon';
import CustomSelect from '../../components/ui/customSelect';

// ----------------------------------------------------------------------

export default function Stats() {
  const theme = useTheme();
  const { eventID } = useParams();
  const [filterType, setFiltreType] = React.useState(1);

  const [events, setEvents] = React.useState();
  const [org, setOrg] = React.useState({});
  const [tmp, setTmp] = React.useState(0);
  const [refresh, setRefresh] = React.useState(0);
  const [tickets, setTicket] = React.useState([]);
  const [stats, setStat] = React.useState([]);
  const [Totalticket, setTotalTicket] = React.useState([]);
  const [repartTicket, setrepartTicket] = React.useState([]);
  const [repartTicket1, setrepartTicket1] = React.useState([]); // repartition des ticket par canal de vente
  const [ticketN, setTicketN] = React.useState([]);

  const [debut, setDebut] = useState();
  const [fin, setFin] = useState();
  // recuperation de la séance
  const [groupDate, setGroup] = React.useState([]);
  const [itemGroup, setItemGroup] = React.useState([]);

  const [openDupplicate, setOpenDupplicate] = useState(false);
  const [openClos, setOpenClos] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const handleClick = (event) => {
    console.log(event.currentTarget);
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = (e) => {
    setAnchorEl(null);
    if (e === 0) {
      setOpenDupplicate(true);
    } else if (e === 2) {
      setOpenClos(true);
    }
  };

  const createEvent = (doc) => {
    setrepartTicket([]);

    setEvents(doc);
  };

  const handleTimestamp = (e) => {

    const date = e.toDate();
    const tmp = date.toJSON().split('.');
    return tmp[0];
  };

  const handleTimestamp1 = (e) => {
    const date = e.toDate();
    const tmp = date.toJSON().split('.');
    const t = tmp[0].split('T');
    return t[1];
  };

  const handleDebut = (e) => {
    setDebut(e);
  };

  const handleFin = (e) => {
    setFin(e);
  };

  React.useEffect(() => {
    const id = eventID;
    let e;
    const docRef0 = doc(db, 'evenement', id);
    setrepartTicket([]);
    setStat([]);

    const fetchData = async () => {
      try {
        // setLoading(true);
        const docSnap = await getDoc(docRef0);
        if (docSnap.exists()) {
          e = docSnap.data();
          createEvent(e);
          console.log(e);
          setTmp(1);
          // setDebut(format(e.createDate.seconds, 'yyyy-MM-dd'))
          if (!debut) {
            setDebut(handleTimestamp(e.createDate));
          }
          if (!fin) {
            setFin(new Date());
          }

          // verification du mode seance
          if (docSnap.data().seanceActive === 1) {
            // recuperation des dates
            const q = query(collection(db, `evenement/${eventID}/seances`), orderBy('date', 'asc'));
            const snapshot = await getDocs(q);
            const tmpd = [];
            const groups = [];
            const group = [];
            snapshot.forEach((d) => {
              // setDates((dates) => [...dates, d]);
              const tmpDate = format(new Date(handleTimestamp(d.data().date)), 'MMM yyyy');
              tmpd.push(d.data());
              const found = groups.find((element) => element === tmpDate);
              if (!found) {
                console.log('not found ');
                groups.push(tmpDate);
              }
            });
            console.log(groups.length);

            // eslint-disable-next-line no-plusplus
            for (let index = 0; index < groups.length; index++) {
              const tgroup = [];
              snapshot.forEach((d) => {
                const tmpDate = format(new Date(handleTimestamp(d.data().date)), 'MMM yyyy');
                if (groups[index] === tmpDate) {
                  tgroup.push(d);
                }
              });
              group.push(tgroup);
            }
            setGroup(groups);
            setItemGroup(group);
          }
        }

        if (events !== null) {
          const q = query(collection(db, `evenement/${eventID}/tickets`));
          const snapshot = await getDocs(q);
          setTotalTicket(snapshot.size);
          setTicketN([]);
          setrepartTicket([]);
          snapshot.forEach((d) => {
            setTicket((tickets) => [...tickets, d]);
            const repart = { label: d.data().ticket_name, value: d.data().sell };
            setrepartTicket((repartTicket) => [...repartTicket, repart]);
            setTicketN((ticketN) => [...ticketN, d.data().ticket_name]);
          });

          // vente par canal
          setrepartTicket1([]);
          const provSnap = await getDoc(doc(db, `evenement/${eventID}/provenance`, `${eventID}`));
          if (provSnap.exists()) {
            if (provSnap.data().ajout) {
              const repart = { label: 'Ajout manuel', value: provSnap.data().ajout };
              setrepartTicket1((repartTicket1) => [...repartTicket1, repart]);
            }
            if (provSnap.data().application) {
              const repart = { label: 'Application', value: provSnap.data().application };
              setrepartTicket1((repartTicket1) => [...repartTicket1, repart]);
            }
            if (provSnap.data().guichet) {
              const repart = { label: 'Guichet', value: provSnap.data().guichet };
              setrepartTicket1((repartTicket1) => [...repartTicket1, repart]);
            }
            if (provSnap.data().site) {
              const repart = { label: 'Site web', value: provSnap.data().site };
              setrepartTicket1((repartTicket1) => [...repartTicket1, repart]);
            }
          }

          const docSnap1 = await getDoc(doc(db, 'organisations', docSnap.data().orgId));
          setOrg(docSnap1.data());

          const statsSnap = await getDocs(query(collection(db, `evenement/${eventID}/stats`)));
          statsSnap.forEach((element) => {
            setStat((stats) => [...stats, element]);
          });
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchData().catch(console.error);
  }, [tmp, refresh]);

  const [sevenDays, setSevenDays] = React.useState([
    '01 jan',
    '02 jan',
    '03 jan',
    '04 jan',
    '05 jan',
    '06 jan',
    '07 jan',
  ]);

  const [sevenDaysData, setSevenDaysData] = React.useState([
    {
      name: 'Tarif normal',
      type: 'line',
      fill: 'solid',
      data: [23, 11, 22, 27, 13, 22, 37],
    },
    {
      name: 'Tarif VIP',
      type: 'line',
      fill: 'solid',
      data: [44, 55, 41, 67, 22, 43, 21],
    },
    {
      name: 'Tarif VVIP',
      type: 'line',
      fill: 'solid',
      data: [4, 60, 20, 67, 96, 30, 20],
    },
    {
      name: 'DELUX',
      type: 'line',
      fill: 'solid',
      data: [30, 25, 36, 30, 45, 35, 64],
    },
  ]);

  // backdrop
  const [openModal, setOpenModal] = useState(false);

  const [seance, setSeance] = React.useState('0');

  // choix de la seance si seance active
  const handleSeance = async (e) => {
    if (e.target.value === '0') {
      setSeance('0')
      setRefresh(!refresh)
      return
    }
    setSeance(e.target.value);
    const index = e.target.value.split('.')
    console.log(itemGroup[index[0]][index[1]].id)
    console.log('id : ', e.target)
    setStat([])
    try {
      const statsSnap = await getDocs(query(collection(db, `evenement/${eventID}/seances/${itemGroup[index[0]][index[1]].id}/stats`)));
      statsSnap.forEach((element) => {
        setStat((stats) => [...stats, element]);
      });
    } catch (error) {
      console.log(error)
    }
  };

  const renderSelectGroup = (index) => {
    const items = itemGroup[index].map((p, j) => (
      <MenuItem key={p.id} value={`${index}.${j}`}>
        <Typography fontSize={{ xs: "1.1rem", md: "1rem" }}>
          {format(new Date(handleTimestamp(p.data().date)), 'EEEE dd MMM yyyy')} - {handleTimestamp1(p.data().date)}
        </Typography>
      </MenuItem>
    ));
    return [<ListSubheader>{groupDate[index]}</ListSubheader>, items];
  };

  /** filter date */
  const [filterBtText, setFilterBtText] = React.useState('Toute la période');
  const [persoDate, setPersoDate] = useState(false);
  const today = () => new Date();

  const subDays = (days) => {
    const d = new Date();
    d.setDate(d.getDate() - days);
    return d;
  };

  const handleFilterDate = async (e) => {

    try {
      const now = new Date();

      switch (e) {
        case 0: // 7 derniers jours
          setFilterBtText('7 derniers jours');
          setPersoDate(false);
          setDebut(subDays(7));
          setFin(now);
          break;

        case 1: // 30 derniers jours
          setFilterBtText('30 derniers jours');
          setPersoDate(false);
          setDebut(subDays(30));
          setFin(now);
          break;

        case 2: // 90 derniers jours
          setFilterBtText('90 derniers jours');
          setPersoDate(false);
          setDebut(subDays(90));
          setFin(now);
          break;

        case 4: // personnalisé
          setFilterBtText('Personnalisé');
          setPersoDate(true);
          // on ne touche pas à debut / fin
          break;

        case 3: // toute la période
          setFilterBtText('Toute la période');
          setPersoDate(false);
          setDebut(events?.createDate?.toDate?.() || now);
          setFin(now);
          break;

        default:
          break;
      }
    } catch (error) {
      console.error(error);
    } finally {
      // setRefresh(!refresh);
      handleCloseMenu();
    }
  };


  return (
    <Page title="Statistique">
      <Backdrop sx={{ color: '#ffff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={openModal}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {events && (
        <Container maxWidth="xl" sx={{ marginTop: { xs: 2 } }}>
          
          <Stack paddingY={2} spacing={2} direction={'row'} alignItems={'center'} justifyContent={'end'}>
            {events.seanceActive === 1 && (
            <FormControl sx={{maxWidth:350}}>
                <Select
                  fullWidth
                  value={seance || ''}
                  onChange={handleSeance}
                  defaultValue={'0'}
                >
                  <MenuItem value={'0'}>
                    <Typography fontSize={{ xs: "1.1rem", md: "1rem" }}>
                      Toutes les seances
                    </Typography>
                  </MenuItem>
                  {groupDate?.map((p, index) => renderSelectGroup(index))}
                </Select>
              </FormControl> )}
            <Button
              onClick={handleClick}
              aria-controls={openMenu ? 'demo-customized-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={openMenu ? 'true' : undefined}
              variant="outlined"
              disableElevation
              size='large'
              endIcon={<LucideIcon name='ChevronDown' />}
              sx={{
                minWidth: 200,
                color: 'text.primary',
                backgroundColor: 'white',
                border: '1px solid gainsboro',
                borderRadius: '12px',
                '&:hover': {
                  backgroundColor: 'white',
                  color: 'black',
                  border: '1px solid gainsboro',
                },
              }}
            >
              {filterBtText}
            </Button>
          </Stack>
          {
            persoDate && <Box sx={{ display:'flex', justifyContent:'end' }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Stack direction="row" spacing={2} sx={{maxWidth:600}}>
                  <DesktopDatePicker
                    disabled={!persoDate}
                    label="depart"
                    inputFormat="DD/MM/YYYY"
                    maxDate={fin}
                    value={debut}
                    onChange={handleDebut}
                    renderInput={(params) => <TextField {...params} fullWidth />}
                  />

                  <DesktopDatePicker
                    label="fin"
                    disabled={!persoDate}
                    fullWidth
                    inputFormat="DD/MM/YYYY"
                    minDate={debut}
                    value={fin}
                    maxDate={Date.now()}
                    onChange={handleFin}
                    renderInput={(params) => <TextField {...params} fullWidth />}
                  />
                </Stack>
              </LocalizationProvider>
            </Box>
          }


          <Grid container spacing={3} paddingTop={2}>
            <Grid item xs={12} md={12} lg={12}>
              {stats.length !== 0 ? (
                <>

                  <AppWebsiteVisits1
                    title={`Evolution des ventes`}
                    chartLabels={sevenDays}
                    chartData={sevenDaysData}
                    chartStat={stats}
                    debut={new Date(debut)}
                    fin={new Date(fin)}
                    ticketName={ticketN}
                  />
                </>
              ) : <Card sx={{ height: 364 }}><Typography fontSize={30} paddingY={10} paddingX={5} textAlign='center'>Vous n'avez pas encore fait de ventes !</Typography></Card>}
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <AppCurrentVisits
                title="Participant par tarif"
                chartData={repartTicket}
                chartColors={[
                  theme.palette.primary.main,
                  theme.palette.chart.blue[0],
                  theme.palette.chart.violet[0],
                  theme.palette.chart.yellow[0],
                ]}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <AppCurrentVisits
                title="Participants par canal de vente"
                chartData={repartTicket1}
                chartColors={[
                  theme.palette.primary.main,
                  theme.palette.chart.blue[0],
                  theme.palette.chart.violet[0],
                  theme.palette.chart.yellow[0],
                ]}
              />
            </Grid>
          </Grid>

          {/** */}
          <StyledMenu
            id="demo-customized-menu"
            MenuListProps={{
              'aria-labelledby': 'demo-customized-button',
            }}
            anchorEl={anchorEl}
            open={openMenu}
            onClose={handleCloseMenu}
          >
            <MenuItem
              onClick={(e) => {
                handleFilterDate(e.target.value);
              }}
              disableRipple
              value={0}
            >
              7 derniers jours
            </MenuItem>
            <MenuItem
              onClick={(e) => {
                handleFilterDate(e.target.value);
              }}
              disableRipple
              value={1}
            >
              30 derniers jours
            </MenuItem>
            <MenuItem
              onClick={(e) => {
                handleFilterDate(e.target.value);
              }}
              disableRipple
              value={2}
            >
              90 derniers jours
            </MenuItem>
            <MenuItem
              onClick={(e) => {
                handleFilterDate(e.target.value);
              }}
              disableRipple
              value={3}
            >
              Toute la période de vente
            </MenuItem>
            <MenuItem
              onClick={(e) => {
                handleFilterDate(e.target.value);
              }}
              disableRipple
              value={4}
            >
              personnalisé
            </MenuItem>
          </StyledMenu>
        </Container>
      )}
    </Page>
  );
}
